import React from 'react'
import gql from 'graphql-tag'
import { Mutation, MutationFn } from 'react-apollo'

export const vulnerabilityPoliciesEnableMutation = gql`
  mutation enableVulnerabilityPolicy($organizationID: ID!, $policyID: ID!) {
    enableVulnerabilityPolicy(
      input: { organizationID: $organizationID, policyID: $policyID }
    ) {
      _placeholder
    }
  }
`

interface ChildProps {
  readonly children: (
    enablePolicy: MutationFn<{}, EanbleVulnerabilityPolicyMutationArgs>
  ) => React.ReactNode
}

interface EanbleVulnerabilityPolicyMutationArgs {
  readonly organizationID: string
  readonly policyID: string
}

export function VulnerabilityPoliciesEnableMutation({ children }: ChildProps) {
  return (
    <Mutation<{}, EanbleVulnerabilityPolicyMutationArgs>
      mutation={vulnerabilityPoliciesEnableMutation}
    >
      {(enablePolicy) => {
        return children(enablePolicy)
      }}
    </Mutation>
  )
}
